export default () => {
  return {
    assessments: [],
    assessmentTypes: [],
    assessmentTypeFieldGroups: [],
    assessmentTypeFields: [],
    assessmentFieldOptions: {},
  };
};
